import { locationSelectAllValue } from '@constants/locationSelectAllValue';
import { initialSorting } from '@constants/tableSorting';

import { useActionItemsStoreAction } from '@pages/ActionItems/store/useActionItemsStore';
import { useActionItemsStorePersistAction } from '@pages/ActionItems/store/useActionItemsStorePersist';
import { useArchiveFiltersActions } from '@pages/Archive/store/useArchiveFiltersStore';
import { useCostSavingsActions } from '@pages/CostSavingsDetails/store/useCostSavingsStore';
import { useAssetHealthOverviewStoreActions } from '@pages/ExecutiveSummary/store/useAssetHealthOverviewFilterStorePersist';
import { useSiteEngagementMetricsFilterStorePersistActions } from '@pages/ExecutiveSummary/store/useSiteEngagementMetricsFilterStorePersist';
import { useManageTranslationsActions } from '@pages/ManageTranslations/store/useManageTranslationsStore';
import { useSensorStoreActions } from '@pages/Sensors/store/useSensorStore';
import { useEngagementFilterActions } from '@pages/SiteEngagement/store/useEngagementFilterStore';
import { useUsersActions } from '@pages/Users/store/useUsersStore';

import { useAppActions } from '@store/useAppStore';

const useResetAllFilters = () => {
  const { setAISort } = useActionItemsStoreAction();
  const { setSiteEngagementMetricsFilterInitialState } = useSiteEngagementMetricsFilterStorePersistActions();
  const { setAIResetFilterState } = useActionItemsStorePersistAction();
  const { setSensorAllFilterReset } = useSensorStoreActions();
  const { setArchiveFiltersInitial } = useArchiveFiltersActions();
  const { setEngagementFilterInitialState } = useEngagementFilterActions();
  const { setUsersResetValues } = useUsersActions();
  const { setAppLocationSelectValue } = useAppActions();
  const { setManageTranslationsInitialState } = useManageTranslationsActions();
  const { setAssetHealthResetSorting } = useAssetHealthOverviewStoreActions();
  const { setCostSavingsSorting } = useCostSavingsActions();

  const resetAllFilter = () => {
    setAISort(initialSorting);
    setSiteEngagementMetricsFilterInitialState();
    setAIResetFilterState();
    setSensorAllFilterReset();
    setArchiveFiltersInitial();
    setEngagementFilterInitialState();
    setUsersResetValues();
    setAppLocationSelectValue(locationSelectAllValue);
    setManageTranslationsInitialState();
    setAssetHealthResetSorting();
    setCostSavingsSorting(initialSorting);
  };

  return { resetAllFilter };
};

export default useResetAllFilters;
